import { useState } from "react";
import { api } from "../../lib/api";
import { useSession } from "../../lib/session";
import { Button, Card, ErrorNote, Field, Input } from "../../components/ui";

export function CreateOrgCard() {
  const { refresh, setOrgId } = useSession();
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<unknown>(null);
  return (
    <Card className="mt-6 p-5">
      <h1 className="text-base font-semibold">Create an organisation</h1>
      <p className="mt-1 text-sm text-fg-2">Every data source, dataset, API key and ledger entry belongs to an organisation.</p>
      <form
        className="mt-4 space-y-3"
        onSubmit={async (e) => {
          e.preventDefault();
          if (name.trim().length < 2) return setError({ message: "Organisation name is required." });
          setBusy(true);
          try {
            const r = await api.orgs.create({ name: name.trim(), kinds: ["provider", "consumer"] });
            setOrgId(r.org.id);
            await refresh();
          } catch (err) {
            setError(err);
          } finally {
            setBusy(false);
          }
        }}
      >
        <Field label="Organisation name">{(p) => <Input {...p} value={name} onChange={(e) => setName(e.target.value)} />}</Field>
        <ErrorNote error={error} />
        <Button type="submit" variant="primary" loading={busy}>
          Create organisation
        </Button>
      </form>
    </Card>
  );
}
